import React from 'react';
import { connect } from 'react-redux';
import { StyleSheet, css } from 'aphrodite';
import { injectIntl } from 'react-intl';
class FiltersSitesDocumentation extends React.Component {
    render() {
        const { intl, theme, filterList, data } = this.props;
        this.styles = styles(theme);
        return (
            <div className={css(this.styles.wrapper)}>
                <ul className={css(this.styles.list)}>
                    <li className={css(this.styles.listItem)} onClick={() => filterList(data.map((site) => site.uuid))}>
                        {intl.formatMessage({ id: 'form.select.all' })}
                    </li>
                    <li className={css(this.styles.listItem)} onClick={() => filterList([])}>
                        {intl.formatMessage({ id: 'form.select.none' })}
                    </li>
                </ul>
            </div>
        );
    }
}

const mapStateToProps = ({ app }) => {
    const { theme } = app;
    return { theme };
};

export default injectIntl(connect(mapStateToProps)(FiltersSitesDocumentation));

const styles = (theme) =>
    StyleSheet.create({
        wrapper: {
            padding: 5,
            marginBottom: 0,
            borderBottom: `solid 1px ${theme.color.borderColor}`,
            textAlign: 'left'
        },
        list: {
            padding: 0,
            margin: 0,
            display: 'table',
            width: '100%',
            color: theme.color.themeColor
        },
        listItem: {
            display: 'table-cell',
            textAlign: 'center',
            ':hover': {
                cursor: 'pointer',
                opacity: '0.8'
            }
        }
    });
